<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <goat-site-main-banner />
  <div class="box-form-wrapper mx-auto max-w-2xl big:max-w-(--breakpoint-xl) big:px-16 mt-5">
    <div
      class="box-form big:mt-10 mx-3 bg-white pt-10 big:pt-16 pb-10 px-2 big:px-16 rounded-2xl flex flex-col items-center"
    >
      <div class="mx-auto w-full max-w-xl">
        <h1 class="text-lg big:text-2xl uppercase font-semibold text-center tracking-wider">
          {{ t('howToDeleteMyData.title') }}
        </h1>
        <h2 class="my-5">
          {{ t('howToDeleteMyData.subtitle') }}
        </h2>
        <ol class="list-decimal pl-3.5 mb-5">
          <li>
            <div class="font-medium">
              {{ t('howToDeleteMyData.item1Title') }}
            </div>
            <div class="my-2">
              {{ t('howToDeleteMyData.item1Text') }}
            </div>
          </li>
          <li>
            <div class="font-medium">
              {{ t('howToDeleteMyData.item2Title') }}
            </div>
            <div class="my-2">
              {{ t('howToDeleteMyData.item2TextBefore') }}
              <a
                href="mailto:privacy@gamesture.com"
                class="text-gs-main-color underline underline-offset-2 font-semibold"
              >privacy@gamesture.com</a>{{ t('howToDeleteMyData.item2TextAfter') }}
            </div>
          </li>
        </ol>
      </div>
    </div>
  </div>
  <goat-site-benefits />
</template>

<style scoped lang="postcss">

</style>
